"use strict";
/* globals module */
/**
 * @module ArticleSubscriptionsRoute
 * @description Baasic Article Subscriptions Article Module Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Subscriptions Article Module Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
var contracts_1 = require("../../core/contracts");
var ArticleSubscriptionsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleSubscriptionsRoute, _super);
    function ArticleSubscriptionsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.subscribeRoute = 'articles/subscriptions';
        _this.isSubscribedRoute = 'articles/subscriptions/{subscriberId}';
        _this.unSubscribeRoute = 'articles/subscriptions';
        return _this;
    }
    /**
     * Parses article module subscribe route which doesn't support any additional options.
     * @method
     * @param data The subscribe information.
     * @example articleSubscriptionsRoute.subscribe(data);
     **/
    ArticleSubscriptionsRoute.prototype.subscribe = function (data) {
        return _super.prototype.baseCreate.call(this, this.subscribeRoute, data);
    };
    /**
     * Parses article module isSubscribed route which must be expanded with subscriber Id
     * @method
     * @param data The subscribe information.
     * @example articleSubscriptionsRoute.isSubscribed({subscriberId: '<subscriber-id>'});
     **/
    ArticleSubscriptionsRoute.prototype.isSubscribed = function (data) {
        return _super.prototype.baseCreate.call(this, this.isSubscribedRoute, data);
    };
    /**
     * Parses article module unSubscribe route which doesn't support any additional options.
     * @method
     * @param data The subscribe information.
     * @example articleSubscriptionsRoute.unSubscribe(data);
     **/
    ArticleSubscriptionsRoute.prototype.unSubscribe = function (data) {
        return _super.prototype.baseCreate.call(this, this.unSubscribeRoute, data);
    };
    var _a;
    ArticleSubscriptionsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleSubscriptionsRoute);
    return ArticleSubscriptionsRoute;
}(common_1.BaseRoute));
exports.ArticleSubscriptionsRoute = ArticleSubscriptionsRoute;
